import { CheckIcon } from '@heroicons/react/outline'
import Player from "@/components/LottiePlayer";

const features = [
  {
    name: 'Pioneers in data',
    description: 'We are a pioneer in the data industry, with over a decade of expertise in developing cutting-edge data tools and applications.',
    icon: "assets/icons/network.json"
  },
  { 
    name: 'Built the first data portals', 
    description: 'We have built the world&apos;s first portals for publishing open data such as <a href="http://data.gov/" target="_blank" ><span>data.gov</span></a> and <a href="http://data.gov.uk/" target="_blank"><span>data.gov.uk</span></a>. ',
    icon: "assets/icons/rocket.json"
  },
  {
    name: 'Creators of CKAN',
    description: 'Our team is proud to be led by the creator of <a href="http://ckan.org" target="_blank"><span>CKAN</span></a> himself, <a href="https://rufuspollock.com/" className="underline" target="_blank"><span>Dr. Rufus Pollock</span></a>, president at Datopian. We are the creators of CKAN, the world&apos;s leading data portal platform and as such, we&apos;ve been building data portals for longer than anyone else. ',
    icon: "assets/icons/boat.json"
  },
  {
    name: 'Work with notable clients',
    description: 'We&apos;ve worked for companies and organizations like <a href="https://www.google.com" className="underline" target="_blank"><span>Google</span></a>, the <a href="https://www.worldbank.org/" className="underline" target="_blank"><span>World Bank</span></a>, and  <a href="https://www.fedex.com/" className="underline" target="_blank"><span>FedEx</span></a>, and have successfully deployed dozens of projects for government, Fortune 500 enterprises and international NGOs.',
    icon: "assets/icons/conference.json"
  },
]

export default function Features() {
  return (
    <div className="bg-white py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 font-['Inter']">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 md:mx-0 md:max-w-none md:grid-cols-2">
          <div tabIndex={0}>
            <h2 className="font-['Inter'] text-orange-400 font-bold mb-1">EVERYTHING YOU NEED</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight sm:text-3xl text-maingray medium-title ">We have helped create the open data movement from the ground up</p>
            <p className="mt-6 body-text text-maingray">
              We make things easy. Our team has clear, established methodologies for implementing data projects which takes the burden off the shoulders of our clients.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-x-8 gap-y-5 text-base leading-7 text-gray-600 sm:grid-cols-1 lg:gap-y-8">
            {features.map((feature) => (
              <div key={feature.name} className="relative md:pl-9" tabIndex={0}>
                <div className='flex justify-start'>
                  <Player
                  autoplay
                  loop
                  src={feature.icon}
                  style={{ height: "50px", width: "50px" }}
                />
                </div>
                <dl>
                  <dt className="font-semibold  small-title">
                  {feature.name}
                  </dt>
                  <dd className="mt-2 body-text" dangerouslySetInnerHTML={{ __html: feature.description }}
                  />
                </dl>
                
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
